import i18next from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: "sv",
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false // React already escapes values
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json"
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"]
    },

    ns: [
      "common",
      "dashboard",
      "campaigns",
      "users",
      "stores",
      "products",
      "discounts",
      "statistics"
    ],
    defaultNS: "common"
  });

export default i18next;
